import { render, staticRenderFns } from "./BackofficeConfirmarReservaSala.vue?vue&type=template&id=eef05f04&scoped=true"
import script from "./BackofficeConfirmarReservaSala.vue?vue&type=script&lang=ts"
export * from "./BackofficeConfirmarReservaSala.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeConfirmarReservaSala.vue?vue&type=style&index=0&id=eef05f04&prod&lang=scss&scoped=true"
import style1 from "./BackofficeConfirmarReservaSala.vue?vue&type=style&index=1&id=eef05f04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef05f04",
  null
  
)

export default component.exports